export const DASHBOARD_VOLUNTEERS_STALE_MS = 5 * 60 * 1000;

export const TASK_LISTING_FIELDS = [
    'id',
    '_id',
    'status',
    'start_at',
    'stop_at',
    'shift_id',
    'phase_id',
    'user_id',
    'user.id',
    'user._id',
    'user.fullname',
    'application_type_id',
    'application_type.id',
    'application_type._id',
    'application.id',
    'application._id',
    'application.application_type_id',
    'activity_id',
    'activity.id',
    'activity._id',
    'activity.code',
    'activity.name',
];

export const SHIFT_LISTING_FIELDS = [
    'id',
    '_id',
    'start_at',
    'stop_at',
    'phase_id',
    'sector_id',
    'nb_volunteers',
    'application_type_id',
    'application_type.id',
    'application_type._id',
];

export const APPLICATION_LISTING_FIELDS = [
    'id',
    '_id',
    'status',
    'nb_hours',
    'busy_rate',
    'application_type_id',
    'application_type.id',
    'application_type._id',
];

export const APPLICATION_TYPE_LISTING_FIELDS = [
    'id',
    '_id',
    'code',
    'name',
    'edition',
    'admin_ids',
    'admins',
    'admins.id',
    'admins._id',
];

export const SECTOR_SCOPE_LISTING_FIELDS = [
    'id',
    '_id',
    'parent_id',
    'code',
    'name',
    'edition',
    'admin_ids',
    'admins',
    'admins.id',
    'admins._id',
];

export const PHASE_LISTING_FIELDS = [
    'id',
    '_id',
    'name',
    'start_at',
    'stop_at',
    'application_type_id',
    'edition',
];
